/* template */
<template minapp="mpx" xlang="wxml"><div :class="(isChange == 1 && 'ticket-change')" class="es-train-information-card"><slot></slot><slot name="divider"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m61e1896c"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-train-information-card
    position relative
    padding 16px 12px 0px
    border-radius 8px 8px 0px 0px
    background #ffffff
    text-align left
  .ticket-change::before
    position absolute
    left 0
    top 0
    content '改签'
    width 88px
    height 32px
    color #ffffff
    // background: #FF7F41;
    background-image url('https://pt-starimg.didistatic.com/static/starimg/img/YilTfWKych1642231273019.png')
    background-size cover
    font-size 20px
    transform-origin top left
    transform scale(0.5)
    text-align center
    line-height 32px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m61e1896c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex61e1896c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex61e1896c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m61e1896c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index61e1896c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
